import { RenderModeEnum } from "../../../typings/spec/common";

import { isMiniAppLikeMode, isMobileLikeMode } from "../../../util/env";

import { DeskTopTrigger } from "./desktop";

import { MobileTrigger } from "./mobile";

export function getDefaultTriggerEventByMode(mode) {
    return mode === RenderModeEnum["desktop-browser"] || mode === RenderModeEnum["desktop-miniApp"] ? {
        start: "pointerdown",
        move: "pointermove",
        end: "pointerup",
        zoom: "wheel",
        zoomEnd: "pointerup",
        scroll: "wheel",
        trigger: DeskTopTrigger
    } : isMobileLikeMode(mode) || isMiniAppLikeMode(mode) ? {
        start: "pointerdown",
        move: "pointermove",
        end: "pointerup",
        zoom: "pinch",
        zoomEnd: "pinchend",
        scroll: "pan",
        scrollEnd: "panend",
        trigger: MobileTrigger
    } : null;
}
//# sourceMappingURL=config.js.map
